import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import {
    autoCompleteReducer,
    docsReducer,
    docUsersReducer,
    pagesReducer,
    readerReducer,
    searchReducer,
    settingsReducer,
    statusReducer,
    userReducer,
} from "./reducers";
import * as sagas from "./sagas";

//@ts-ignore
const rootReducers = combineReducers({
    docs: docsReducer,
    doc_users: docUsersReducer,
    pages: pagesReducer,
    user: userReducer,
    settings: settingsReducer,
    autocomplete: autoCompleteReducer,
    reader: readerReducer,
    search: searchReducer,
    status: statusReducer,
});

export type AppState = ReturnType<typeof rootReducers>;

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
    //@ts-ignore
    rootReducers,
    composeWithDevTools(applyMiddleware(sagaMiddleware))
);

Object.entries(sagas).forEach(([_k, v]) => sagaMiddleware.run(v));

export { store };
